
/** Génére une requete et gère la conversion promesse / try  catch pour utiliser yield */
function _doReq(url, method, isJSON, jsonBody) {
  let headers = new Headers();
  headers.append('Accept', 'application/json');
  if (jsonBody !== undefined) {
    headers.append('Content-Type', 'application/json');
  }
  let token;
  try {
      sessionStorage.setItem('safariTest', 'ok');
      token = sessionStorage.getItem('token');
  } catch(e) {
      token = window.STORAGE_TOKEN;
  }
  if (token !== undefined && token !== null) {
    headers.append('Authorization', `Bearer ${token}`);
  }
  const request = new Request(url, {
    headers: headers,
    method: method,
    body: jsonBody ? JSON.stringify(jsonBody) : undefined
  });

  return fetch(request, { credentials: 'include' })
    .catch(function () {
      return new Error('HTTP Exception');
    }).then(function (res) {
      if (res.status !== 200) {
        return new Error('HTTP Status code exception');
      } else if (isJSON) {
        return res.json();
      } else {
        return res;
      }
    });
}


/** Pré-configuration de _doReq pour les requêtes faites par l'application */
export default {
  json: {
    'get': (url) => _doReq(url, 'GET', true),
    'put': (url, payload) => _doReq(url, 'PUT', true, payload),
    'post': (url, payload) => _doReq(url, 'POST', true, payload)
  },
  'delete': (url) => _doReq(url, 'DELETE', false)
};



// WEBPACK FOOTER //
// ./src/redux/_utils/httpSaga.js